export const courses = {
  title: "Cours",
  subtitle: "Formation spécialisée pour éducateurs, mères et pères",
  accompaniment: {
    title: "Cours d'accompagnement:",
    subtitle: "Accompagner les filles et les garçons (2025-2026)",
    description: "Outils personnels pour l'accompagnateur/trice. Le plaisir d'apprendre par découverte.\n\nCours de formation destiné aux éducateurs/trices, mères et pères dans lequel nous utiliserons une méthodologie participative, avec des moments pour réfléchir et partager, en consacrant beaucoup de temps à vivre et pratiquer les compétences liées à chaque sujet.",
    trainers: {
      title: "Formateurs",
      names: "Tinus Wijnakker et Beatriz Aguilera Reija, fondateurs de l'école Alavida à Madrid avec 25 ans d'expérience."
    },
    duration: {
      title: "Durée",
      block1: "1er bloc: 24 heures",
      block2: "2ème bloc: 24 heures", 
      block3: "3ème bloc: 36 heures"
    },
    dates: {
      title: "Dates",
      block1: "1er bloc",
      block1Dates: "7-8 novembre / 28-29 novembre",
      block2: "2ème bloc", 
      block2Dates: "23-24 janvier / 20-21 février",
      block3: "3ème bloc",
      block3Dates: "27-28 mars/ 24-25 avril /22-23 mai"
    },
    schedule: {
      title: "Horaire",
      friday: "Vendredi",
      fridayTime: "de 17h30 à 21h30",
      saturday: "Samedi", 
      saturdayTime: "de 9h00 à 13h30 et de 15h00 à 18h30"
    },
    location: {
      title: "Lieu",
      place: "Gándara International School"
    },
    capacity: {
      title: "Capacité maximale",
      block1: "Premier bloc: capacité maximale: 25 personnes",
      blocks23: "Deuxième et Troisième bloc: capacité maximale: 30 personnes. (Les participants de cours précédents peuvent aussi s'inscrire)."
    },
    prices: {
      title: "Prix",
      fullEarly: "Cours complet (en payant avant le 10 octobre): 500€",
      fullBlocks: "Cours complet (en payant en trois blocs): 160€ + 160€ + 240€ = 560€",
      block12: "Bloc 1 ou 2 séparément: 170€",
      block3: "Bloc 3: 240€",
      note1: "Pour participer uniquement au bloc 3, il sera nécessaire d'avoir suivi préalablement une formation avec Tinus Wijnakker.",
      note2: "Les personnes qui s'inscrivent au cours complet ont la priorité."
    },
    content: {
      title: "CONTENU DU COURS:",
      blocks12: {
        title: "1er et 2ème bloc: Outils personnels pour l'accompagnateur/trice",
        instructor: "Dirigé par Tinus Wijnakker",
        block1: {
          title: "Bloc 1 - 1er week-end (7-8 novembre)",
          topic: "L'observation et les processus de communication:",
          point1: "Comment observons-nous? et Comment notre façon d'observer nous affecte-t-elle?",
          point2: "L'importance de voir et comprendre les signaux de communication.",
          point3: "La communication non-verbale et verbale",
          point4: "Comment interpréter les messages des filles et des garçons?"
        },
        weekend2: {
          title: "2ème week-end (28-29 novembre)",
          topic: "L'écoute active:",
          point1: "Écouter pour comprendre et accompagner.",
          point2: "Le langage de l'acceptation: Refléter et accompagner.",
          point3: "La communication non-verbale et le contact physique"
        }
      },
      block2: {
        title: "Bloc 2",
        weekend3: {
          title: "3ème week-end (23-24 janvier)",
          topic1: "Amour et sécurité:",
          point1: "Besoins fondamentaux.",
          point2: "Comment quelqu'un se sent-il aimé/e et en sécurité?",
          point3: "Soutien émotionnel.",
          point4: "Écouter, accepter et accompagner les sentiments.",
          topic2: "Liberté, limites et autonomie:",
          point5: "Un environnement détendu.",
          point6: "Limites, règles de coexistence et punitions.",
          point7: "Liberté et autonomie."
        },
        weekend4: {
          title: "4ème week-end (20-21 février)",
          topic: "Situations conflictuelles:",
          point1: "Conflits, agressivité et violence.",
          point2: "Analyser une situation conflictuelle.",
          point3: "Accompagner pour faciliter le processus de régulation."
        }
      },
      block3: {
        title: "Bloc 3: Le plaisir d'apprendre par découverte.",
        instructors: "Dirigé par Beatriz Aguilera et Tinus Wijnakker",
        weekend5: {
          title: "5ème week-end (27-28 mars)",
          topic1: "Étapes évolutives:",
          point1: "Enfance: de 0 à 6 ans: étape sensori-motrice-affective",
          point2: "Enfance: de 6 à 12 ans: étape des opérations concrètes",
          topic2: "Environnements préparés:",
          point3: "Les coins.",
          point4: "Les structures."
        },
        weekend6: {
          title: "6ème week-end (24-25 avril)",
          topic1: "Le rôle de l'adulte:",
          point1: "Le lien et le soutien émotionnel",
          point2: "Guide et référence.",
          topic2: "La coexistence:",
          point3: "Le processus de relations personnelles et de groupe.",
          point4: "Responsabilités et autonomie.",
          point5: "Limites, règles de coexistence et conséquences.",
          point6: "Les situations de conflits."
        },
        weekend7: {
          title: "7ème week-end (22-23 mai)",
          topic: "Le processus d'apprentissage:",
          point1: "Comment apprennent les filles et les garçons?",
          point2: "Facteurs sociaux et émotionnels.",
          point3: "La curiosité et l'intérêt comme moteurs d'apprentissage",
          point4: "Apprentissage autonome",
          point5: "Présentations",
          point6: "L'apprentissage par découverte"
        }
      }
    }
  },
  psychomotricity: {
    title: "COURS DE PSYCHOMOTRICITÉ ÉDUCATIVE",
    subtitle: "\"Psychomotricité dans l'éducation infantile et premier cycle du primaire. Théorie et ressources pour la classe\"",
    dateTime: {
      title: "Date et Horaire",
      details: "25 octobre de 10h00 à 17h00 à Gándara School à Gondomar."
    },
    price: {
      title: "Prix",
      amount: "60€/personne"
    },
    lunchNote: "Il y aura une pause déjeuner, nous recommandons d'apporter une boîte-repas avec de la nourriture et de profiter de l'espace et de la compagnie pendant ce temps de repos.",
    content: {
      title: "Contenu du cours:",
      point1: "Travail de sensibilisation corporelle",
      point2: "Initiation à la théorie de la psychomotricité relationnelle",
      point3: "Jeux et dynamiques corporelles pour travailler dans les cycles éducatifs 3-8 ans",
      point4: "Nous passerons en revue les aspects fondamentaux de la pratique psychomotrice",
      point5: "Nous adapterons les dynamiques selon les besoins éducatifs des personnes participant à la formation pour que vous ayez des ressources à utiliser en classe",
      point6: "Vous repartirez avec des textes de théorie et de pratique pour approfondir les connaissances après la formation."
    }
  },
  contact: {
    title: "Plus d'informations et inscriptions",
    description: "Pour plus d'informations et/ou inscriptions:"
  }
};